module.exports = {
      id: "culture--marker-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#culture--marker-usage",
      toString: function () {
        return this.url;
      }
    }